import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c(VRow, [_c(VCol, {
    staticClass: "mb-2 pb-0 mt-0 pt-0",
    attrs: {
      "cols": "12",
      "md": "9"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$i18n_t('Connectors.Connectors.statusLogs.description')) + "\n    ")]), _c(VCol, {
    staticClass: "mb-2 pb-0 mt-0 pt-0",
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('div', {
    staticClass: "d-flex align-center justify-end"
  }, [_c('core-button', {
    staticClass: "ma-0 mx-3",
    attrs: {
      "color": _vm.color,
      "prepend-icon": "fa-sync"
    },
    on: {
      "click": _vm.fetchConnectorLogs
    }
  }), _c('span', {
    staticClass: "text-uppercase text-caption"
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('Connectors.Connectors.lastRefreshed')) + ":\n          "), _vm.lastRefreshed ? [_vm._v("\n            " + _vm._s(_vm.localizeDate(_vm.lastRefreshed, this, {
    time: {
      withSeconds: true
    }
  })) + "\n          ")] : [_vm._v("\n            " + _vm._s(_vm.$i18n_t('Common.loading')) + "\n          ")]], 2)], 1)]), _c(VCol, {
    staticClass: "mb-2 pb-0 mt-0 pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c(VTextField, {
    attrs: {
      "placeholder": _vm.$i18n_t('Connectors.Connectors.searchLogsPlaceholder'),
      "clearable": "",
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "color": _vm.color,
      "data-cy": "connectorLogsSearch"
    },
    on: {
      "input": _vm.updateSearchQuery
    },
    model: {
      value: _vm.searchQuery,
      callback: function ($$v) {
        _vm.searchQuery = $$v;
      },
      expression: "searchQuery"
    }
  })], 1), _c(VCol, {
    staticClass: "mb-0 pb-0 mt-0 pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('Connectors.Connectors.history')) + "\n          "), _c('core-n20-card', {
    staticClass: "dt-card-text-01 pa-0"
  }, [_vm.isLoadingLogs ? [_c('div', {
    staticClass: "log-items-inner"
  }, [_c('div', {
    staticClass: "empty-state"
  }, [_c(VProgressCircular, {
    attrs: {
      "color": _vm.color,
      "indeterminate": ""
    }
  })], 1)])] : !_vm.isLoadingLogs && _vm.hasNoPackets ? [_c('div', {
    staticClass: "log-items-inner"
  }, [_c('div', {
    staticClass: "empty-state"
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('Connectors.Connectors.statusLogs.noLogsReceived')) + "\n                ")])])] : _vm.filteredConnectorLogs.length === 0 && (_vm.searchQuery || '').trim() ? [_c('div', {
    staticClass: "log-items-inner"
  }, [_c('div', {
    staticClass: "empty-state"
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('Common.noResults')) + "\n                ")])])] : [_c('div', {
    staticClass: "log-items-inner"
  }, _vm._l(_vm.filteredConnectorLogs, function (logItem) {
    return _c('div', {
      key: logItem.id,
      class: {
        'log-item': true,
        active: _vm.activeItemId === logItem.id
      },
      on: {
        "click": function ($event) {
          return _vm.handleItemSelected(logItem);
        }
      }
    }, [_c(VIcon, {
      attrs: {
        "color": _vm.getLogLevelColor(logItem.meta.level)
      }
    }, [_vm._v("\n                    fas " + _vm._s(_vm.getLogLevelIcon(logItem.meta.level)) + "\n                  ")]), _vm._v("\n                  " + _vm._s(_vm.localizeDate(logItem.createdAt, this, {
      time: {
        withSeconds: true
      }
    })) + "\n                ")], 1);
  }), 0)]], 2)], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "9"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('Connectors.Connectors.payload')) + "\n          "), !_vm.logItemPayload ? _c('core-n20-card', {
    staticClass: "dt-card-text-01"
  }, [_c('div', {
    staticClass: "log-items-inner"
  }, [_c('div', {
    staticClass: "empty-state"
  }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('Connectors.Connectors.statusLogs.noLogselected')) + "\n              ")])])]) : _c('core-n20-card', {
    staticClass: "dt-card-text-01 payload"
  }, [_vm.isJsonPayload(_vm.logItemPayload) ? [_c('json-viewer', {
    attrs: {
      "value": _vm.logItemPayload,
      "expand-depth": 2,
      "expanded": ""
    }
  })] : [_vm._v("\n              " + _vm._s(_vm.logItemPayload) + "\n            ")]], 2)], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };